export enum IconName {
  ArrowDown = 'ArrowDown',
  Checkmark = 'Checkmark',
  Continue = 'Continue',
  DFINLogo = 'DFINLogo',
  EdgarNextLogo = 'EdgarNextLogo',
  Error = 'Error',
  Exit = 'Exit',
  Help = 'Help',
  Info = 'Info',
  NavArrow = 'NavArrow',
  Success = 'Success',
  User = 'User',
  Users = 'Users',
}
